<script lang="ts">
  import { link } from "svelte-routing"
  import { Button, Col, Row, Table, Spinner } from "sveltestrap"
  import InfiniteScroll from "svelte-infinite-scroll";
  import WithdrawModal from "./WithdrawModal.svelte"
  import Image from "./Image.svelte"
  import { getBidList, getBids, getRoundList } from "../stores/query"
  import { chainId, connected, selectedAccount } from "svelte-web3"
  import { query } from "@urql/svelte"
  import { currentChainId } from "../stores/store"
  import { convertBid, convertBids, convertRound, nFormatter } from "../utils/utils"
  import PilTooltip from "./PilTooltip.svelte"

  let columns = ['Item', 'Title', 'Offer Price', 'Offer Deadline', 'metaNFT ID', 'Status', 'Action'];
  let loadDone = false;

  let tooltips = {
    'Offer Price': 'Full buyouts are only available at a higher price than the current spot price determined by the AMM. This is the maximum price you can pay when your bid is accepted.',
    'Offer Deadline': 'When the offer is no longer active',
    'Status': 'Status of the offers.',
  }

  let bidList = [];

  let isEndReached = false;
  let isLoading = false;
  let currentOffset = 0;

  const paginationStep = 10;


  const convertAndConcatFetchedBidList = (page, reset) => {
    reset = reset === true;
    const convertPromises = page.map((elem) => {
      return convertBid($currentChainId, elem);
    })
    Promise.allSettled(convertPromises).then(res => {
      isLoading = false;
      if (reset) {
        bidList = res.filter(e => e.status === 'fulfilled').map(e => e.value);
      } else {
        bidList = bidList.concat(res.filter(e => e.status === 'fulfilled').map(e => e.value));
      }
    })
  }

  const fetchBidList = (reset) => {
    if (reset === true) {
      isEndReached = false;
      currentOffset = 0;
    }
    const data = {
      address: $selectedAccount,
      limit: paginationStep,
      offset: currentOffset,
    };

    if (isEndReached || isLoading || !$connected) {
      return;
    }
    isLoading = true;
    getBidList($currentChainId, data).then(res => {
      const data = res.user.bids;
      if (data.length === 0) {
        isEndReached = true;
      }
      convertAndConcatFetchedBidList(data, reset);
      currentOffset += paginationStep
    }).catch(e => {console.error(e); isLoading= false;});
  }

  $: if ($connected) {
    isLoading = false;
    isEndReached = false;
    currentOffset = 0;
    fetchBidList(true);
  }

</script>

<table class="pil-table">
  <thead>
  <tr>
    {#each columns as column}
      <th class={'table-header ' + (column === 'Title' ? 'table-title' : '')}>
        {column}
        {#if tooltips.hasOwnProperty(column)}
          <PilTooltip tooltipId={`pos-bid-${column.replace(/ /i, '-')}`}>{tooltips[column]}</PilTooltip>
        {/if}
      </th>
    {/each}
  </tr>
  </thead>
  <tbody>
  {#each bidList as row}
    <tr>
      <td class="table-thumbnail-col">
        <a href={`/nft/${row.metaNftId}`} use:link>
          <Image src={row.image} table={true}/>
        </a>
      </td>
      <td class='table-title'>
        <a class="table-title-link" href={`/nft/${row.metaNftId}`} use:link>
          {row.title}
        </a>
      </td>
      <td>
        {nFormatter(row.amountIn, 2)} {row.baseToken}
      </td>
      <td>
        {row.expiry}
      </td>
      <td>
        {row.metaNftId}
      </td>
      <td class={row.status.startsWith('ACTIVE') ? 'pf-table-primary' : ''}>
        {row.status}
      </td>
      <td class="table-action">
        <Row class="col-auto">
          <Col>
            {#if row.action === 'Withdraw'}
              <WithdrawModal action={row.isNft ? 'unbidNft' : 'unbidMetaNft'} data={row}/>
            {/if}
          </Col>
        </Row>
      </td>
    </tr>
  {/each}
  </tbody>
</table>
{#if isLoading}
  <div class="spinner-div"><Spinner light size="lg" /></div>
{/if}
<InfiniteScroll threshold={10} on:loadMore={fetchBidList} window={true} />

<style>
    .spinner-div {
        margin-top: 30px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>

